import { TimberBuyerEdit, TimberBuyerEditSkeleton } from '@features/TimberBuyer/Edit'
import { useTimberBuyerContext } from '@features/TimberBuyer/TimberBuyerContext'
import { createFileRoute } from '@tanstack/react-router'

const TimberBuyerEditRoute: React.FC = () => {
  const { timberBuyerId } = Route.useParams()
  const { data, isLoading } = useTimberBuyerContext()

  if (isLoading || !data) {
    return <TimberBuyerEditSkeleton />
  }

  return <TimberBuyerEdit data={data} timberBuyerId={timberBuyerId} />
}

export const Route = createFileRoute('/timberbuyer/$timberBuyerId/edit/')({
  component: TimberBuyerEditRoute,
  staticData: {
    breadcrumb: 'Endre tømmerkjøperopplysninger',
  },
})
